import { Box } from '@mui/material';
import ProgressBarCard from '/@/components/crop-monitoring/progress-bar-cards/card';
import { _ } from '/@/locale';

const ProgressBarCards = ({ cropMonitoring, steps, activeStep, getDate, expectedFloweringDate, showAlert }) => {
    const dataState = {
        emergence: _('Siembra Emergencia'),
        flowering: _('Emergencia Vegetativo'),
        maturity: _('Floración Madurez'),
        harvested: _('Cosechado'),
    };

    const getColorStep = (step, index, activeStep) => {
        if (!cropMonitoring?.id) return 'mute';
        if (activeStep > index) {
            return step.stage;
        }
        return 'mute';
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                ml: 1,
            }}
        >
            {steps.map((step, index) => {
                const dataStateText = index === steps.length - 2 ? _('Madurez Fisiológica') : dataState[step.stage];
                return (
                    !step.empty && (
                        <ProgressBarCard
                            date={getDate(step, index)}
                            step={step}
                            stateText={dataStateText}
                            color={getColorStep(step, index, activeStep)}
                            key={index}
                            expectedFloweringDate={expectedFloweringDate}
                            showAlert={showAlert}
                        />
                    )
                );
            })}
        </Box>
    );
};

export default ProgressBarCards;
